import React from 'react';

const Unauthorized = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>403 - Unauthorized</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default Unauthorized;
